"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const validators_1 = require("../../utils/validators");
class AnalyzerController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            listAnalyzer: '/connector/cortex/analyzer?range=all',
            listJob: '/connector/cortex/job/_search?range=0-200&sort=-startDate',
            executeJob: '/connector/cortex/job',
            bulkJob: '/connector/cortex/job/_bulk',
            getJob: '/connector/cortex/job/:jobId?nstats=true',
        };
    }
    create({}) {
        throw new Error("Can't create analyzers!");
    }
    edit({}) {
        throw new Error("Can't edit analyzers!");
    }
    delete() {
        throw new Error("Can't delete analyzers!");
    }
    listAnalyzer() {
        return this.manager.get({ url: this.endpoints.listAnalyzer });
    }
    listJob(observableId) {
        (0, validators_1.isRequired)(observableId);
        return this.manager.post({ url: this.endpoints.listJob }, {
            query: {
                _and: [
                    {
                        _parent: {
                            _type: 'case_artifact',
                            _query: {
                                _id: observableId,
                            },
                        },
                    },
                ],
            },
        });
    }
    getJob(jobId) {
        (0, validators_1.isRequired)(jobId);
        return this.manager.get({ url: this.endpoints.getJob, params: { jobId } });
    }
    multipleExecuteJob(data) {
        return this.manager.post({ url: this.endpoints.bulkJob }, {
            jobs: data.map(({ analyzerId, cortexId, observableId: artifactId }) => ({
                analyzerId,
                cortexId,
                artifactId,
            })),
        });
    }
    executeJob({ observableId, analyzerId, cortexId }) {
        return this.manager.post({ url: this.endpoints.executeJob }, {
            artifactId: observableId,
            analyzerId,
            cortexId,
        });
    }
}
exports.default = AnalyzerController;
